import { Filter } from '@/interfaces/filter.interface'
import { APIPermission } from '@/models/api/permission.model'
import { APIRole } from '@/models/api/role.model'
import { RolesServices } from '@/services/modules/roles.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class RolesStore extends VuexModule {
    roles: object[] = []
    rolesPaginate: object[] = []
    roleForm: object|null = null

    @Mutation
    updateRoles (newRoles: object[]) {
        this.roles = newRoles
    }

    @Mutation
    rolesPaginatePaginate (newRoles: object[]) {
        this.rolesPaginate = newRoles
    }

    @Mutation
    updateRole (newRole: object) {
        this.roleForm = newRole
    }

    @Action
    getRoles () {
        return new Promise((resolve) => {
            RolesServices.getRoles()
                .then(resp => {
                    store.commit('updateRoles', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getRolesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = {
                page: params.page,
                limit: params.limit,
                sortBy: params.sortBy,
                sort: params.sort
            }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            RolesServices.getRolesPaginate(newParams)
                .then(resp => {
                    store.commit('rolesPaginatePaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getRolesById (id: number) {
        return new Promise((resolve) => {
            RolesServices.getRolesById(id)
                .then(resp => {
                    store.commit('updateRole', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editRoles (params: APIRole) {
        params = new APIRole(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIRole)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            RolesServices.editRoles(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createRoles (params: APIRole) {
        params = new APIRole(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIRole)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            RolesServices.createRoles(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteRoles (id: number) {
        return new Promise((resolve) => {
            RolesServices.deleteRoles(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    addPermissionToRole ({ roleId, permissions }: { roleId: number; permissions: APIPermission[] }) {
        return new Promise((resolve) => {
            const permissionList: number[] = []

            permissions.forEach(perm => {
                if (perm.permissionId) permissionList.push(perm.permissionId)
            })

            RolesServices.addPermissionToRole(roleId, permissionList)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    removePermissionToRole ({ roleId, permissions }: { roleId: number; permissions: APIPermission[] }) {
        return new Promise((resolve) => {
            const permissionList: number[] = []

            permissions.forEach(perm => {
                if (perm.permissionId) permissionList.push(perm.permissionId)
            })

            RolesServices.removePermissionToRole(roleId, permissionList)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
